/* @flow */

import * as React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import Localizer from '../../helpers/localization';
import { Messenger, MessengerEvents } from '../../helpers/messenger';
import DebugPicto from '../pictos/DebugPicto';
import './Version.css';

const Version = (): React.Node => {
  const isDebugModeEnabled = useSelector<boolean>((state) => state.appConfiguration.isDebugModeEnabled);
  const version = useSelector<string>((state) => state.appConfiguration.versionAppShort);

  const handleVersionOnClick = useCallback((event: SyntheticMouseEvent<HTMLElement> | SyntheticTouchEvent<HTMLElement>) => {
    if ((event.ctrlKey || event.altKey) && event.shiftKey) {
      Messenger.emit(MessengerEvents.TOGGLE_DEBUG_MODE);
    }
  }, []);

  return (
    <div className='footerVersion' onClick={handleVersionOnClick}>
      <div>{Localizer.localize('footer.version', { version })}</div>
      <DebugPicto isEnabled={isDebugModeEnabled} />
    </div>
  );
};

export default Version;
